<template>
  <div class="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="w-auto h-12 mx-auto" src="@/assets/logo.png"  />
    <h2 class="mt-6 text-3xl font-extrabold leading-9 text-center text-gray-900">
      Entra nel tuo account
    </h2>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
      <form v-on:submit.prevent="login">
        <div>
          <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
            Email
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input v-model="form.email" id="email" type="email" required class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none sm:text-sm sm:leading-5" />
          </div>
          <p class="mt-2 text-xs text-red-600" v-if="errors.email">
            {{ errors.email[0] }}
          </p>
        </div>

        <div class="mt-6">
          <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
            Password
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input v-model="form.password" id="password" type="password" required class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none sm:text-sm sm:leading-5" />
          </div>
          <p class="mt-2 text-xs text-red-600" v-if="errors.password">
            {{ errors.password[0] }}
          </p>
        </div>

        <div class="flex items-center justify-between mt-6">
          <div class="text-sm leading-5">
            <a @click="goToReset()" class="font-medium text-indigo-600 transition duration-150 ease-in-out cursor-pointer hover:text-indigo-500 focus:outline-none focus:underline">
              Password dimenticata?
            </a>
          </div>
        </div>

        <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <button  type="submit" class="flex justify-center w-full px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700">
              Login
            </button>
          </span>
        </div>

                <div class="mt-6">
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm leading-5">
              <span class="px-2 text-gray-500 bg-white">
                    Non hai un account?
              </span>
            </div>
          </div>

          <div class="mt-6">
            <div>
              <span class="inline-flex w-full rounded-md shadow-sm">
                <router-link :to="{name:'Register'}" class="inline-flex justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md cursor-pointer hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue" aria-label="Sign in with Facebook">
                  Registrati ora!
                </router-link>
              </span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import Api from "../apis/Api";
//import User from '../apis/User';
export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errors: []
    };
  },
  mounted() {
    if (localStorage.getItem("isAuth") == "true"){
      this.$router.push({ name: "Dashboard"});
    }
    Api.get("/csrf-cookie");
  },
  methods: {
    login() {

/*
      User.login(this.form).then(() => {
        localStorage.setItem("isAuth", true)
        this.$router.push({ name: "Dashboard" });

      })
      .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
      */
      this.$store
        .dispatch("signIn", this.form)
        .then( () => {
          localStorage.setItem("isAuth", true);
          window.location.href = "/";

          //await new Promise(r => setTimeout(r, 2000));
          //this.redirect();

        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
      
    },

    async redirect() {
      await this.$store.dispatch("me");
      await this.$router.push({ name: "Dashboard" }).catch(async err => {
      console.log('all good'+err)
      // eslint-disable-next-line no-unused-vars
      await new Promise(r => setTimeout(this.redirect(), 2000));
      })
    },

    goToReset(){
      window.location = process.env.VUE_APP_RESET_PASSWORD;
    },

    goToRegister(){
      window.location = process.env.VUE_APP_REGISTER;
    }

    
  }
};
</script>